export { default } from './CategoryPageLayout';
